import { collection, onSnapshot, orderBy, query, where } from "firebase/firestore";
import { useCallback, useEffect, useState } from "react";
import { HbrCommentIcon } from "./Mycustomsvgicons";
import { formatNumber } from "./GeneralClasses";
import db from "../firebase";

const LiveCommentCount = ({showChat,docIDstofetch,handleShowComment}) => {
    const [lastCommentDocs,setLastcommentDoc]=useState([]);

     const fetchDocsWhenChatIsHidded=useCallback(()=>{
        let unsub;

        try {
          if (docIDstofetch !== "") {
            const collectionref = collection(db,"liveComments");
            const q = query(collectionref,where("docID",">=",docIDstofetch), orderBy('docID','asc'));
            unsub = onSnapshot(q, (snapshot)=>{
                const items = [];
                snapshot.forEach((doc)=>{
                    items.push(doc.data());
                });
                setLastcommentDoc(items);
                
            });
            return unsub;
          }
      
        } catch{
            
        }
   
      },[docIDstofetch]);

    useEffect(()=>{
        // const unsub =  fetchDocsWhenChatIsHidded();
        // return()=>{
        //   if (unsub) {
        //       unsub();
        //   }
        // }
        fetchDocsWhenChatIsHidded();
      },[fetchDocsWhenChatIsHidded]);

      const handleOpenSideComments=()=>{
        handleShowComment(true);
        setLastcommentDoc([]);
      };

      // useEffect(()=>{
      //   if (showChat) {
      //     setLastcommentDoc([])
      //   }
      // },[showChat]);


    return ( 

    <div className={`showlivecomment ${showChat ? 'hide':'show'}`} 
        style={{position:"absolute",top:"2em",right:"2em",backgroundColor:"#10101080",cursor:"pointer",display:"flex"}}
        onClick={handleOpenSideComments}>
        <HbrCommentIcon width="1.7em" height="1.7em" fillColour="white"/>
        <pre style={{color:"red",fontWeight:"bold"}}>{lastCommentDocs.length !==0 && formatNumber(lastCommentDocs.length)}</pre>
   </div>
     );
}
 
export default LiveCommentCount;